export function toHiragana(str: string) {
  return str.replace(/[\u30A1-\u30F6]/g, c =>
    String.fromCharCode(c.charCodeAt(0) - 0x60)
  );
}

export const KANJI_RE = /[\u4e00-\u9faf\u3400-\u4dbf]/;
export const JAPANESE_RE = /[\u3040-\u9fff]/;
export const INFLECTING_POS = new Set(['動詞', '形容詞', '形容動詞']);
